import { useState } from "react";
import client from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

/** Click-to-reveal md hash for the m-result iframe components. The value is
 * only fetched on first click; the backend rejects the request for anyone but
 * System Admin / MHQ Admin / SAD (dealer.md_hash.view), and the caller only
 * renders this for them. */
export function MdHashField({ dealerId }) {
  const { t } = useI18n();
  const [value, setValue] = useState(null);
  const [shown, setShown] = useState(false);
  const [loading, setLoading] = useState(false);

  const toggle = async () => {
    if (shown) {
      setShown(false);
      return;
    }
    if (value === null) {
      setLoading(true);
      try {
        const { data } = await client.get(`/dealers/${dealerId}/md-hash`);
        setValue(data.md_hash || "");
      } catch {
        toast.error(t("dealership.mdHashLoadFailed"));
        setLoading(false);
        return;
      }
      setLoading(false);
    }
    setShown(true);
  };

  return (
    <div className="mt-2 flex items-center gap-2 font-mono text-[11px] text-muted-foreground" data-testid="dealer-md-hash">
      <span>{t("dealership.mdHash")}:</span>
      {shown ? (
        <span className="select-all text-foreground" data-testid="dealer-md-hash-value">
          {value || t("dealership.mdHashUnavailable")}
        </span>
      ) : (
        <span>••••••••••••••••••••••••••••••••</span>
      )}
      <button
        type="button"
        onClick={toggle}
        disabled={loading}
        className="inline-flex items-center gap-1 rounded border border-border px-1.5 py-0.5 hover:bg-muted"
        data-testid="dealer-md-hash-toggle"
      >
        {shown ? <EyeOff className="h-3 w-3" /> : <Eye className="h-3 w-3" />}
        {shown ? t("dealership.mdHashHide") : t("dealership.mdHashReveal")}
      </button>
    </div>
  );
}
